export default __webpack_public_path__ + "static/media/Vanir Warriors Cache.a1462424.jpg";